import React from "react";
import { useDraggableSheet } from "../../../helpers/hooks";
import './ViewNetworksSheet.scss';
import Icon from "../Icon/Icon";

const SOCIALS = [
  {
    key: "youtube",
    label: "Youtube",
    icon: "/social-icons/youtube.svg",
  },
  {
    key: "facebook",
    label: "Facebook",
    icon: "/social-icons/facebook.svg",
  },
  {
    key: "instagram",
    label: "Instagram",
    icon: "/social-icons/instagram.svg",
  },
  {
    key: "twitter",
    label: "X",
    icon: "/social-icons/x.svg",
  },
];

const ViewNetworksSheet = ({ instagram, facebook, twitter, youtube, onClose }) => {
  const links = { instagram, facebook, twitter, youtube };
  const { sheetStyle, overlayHandlers } = useDraggableSheet({ onClose });

  const handleClick = (key) => {
    const url = links[key];
    if (url) {
      window.open(url, '_blank');
    }
  };


  const socials = SOCIALS.filter(social => links[social.key]);
  return (
    <div className="view-networks-sheet-overlay" {...overlayHandlers}>
      <div className="sheet" style={sheetStyle} onClick={e => e.stopPropagation()}>
        <div className="pull-bar" />
        <div className="title fg-crea fs-xs fw-medium-bold fw-bold mb-24 mt-8 fs-md2 ta-center">View Networks</div>
        <div className="d-flex aic jcc mb-8" style={{ gap: 32 }}>
          {socials && socials.length > 0 ? socials.map(({ key, label, icon }) => (
            <div
              key={key}
              className="d-flex f-column aic jcc network-icon-btn"
              style={{ cursor: links[key] ? 'pointer' : 'not-allowed', opacity: links[key] ? 1 : 0.4 }}
              onClick={() => handleClick(key)}
            >
              <img src={icon} alt={label} width={40} height={40} />
              <span className="fs-xs mt-4" style={{ fontWeight: 500 }}>{label}</span>
            </div>
          )) : (
            <div className="d-flex f-column aic jcc">
              <span className="fs-xs mt-4 fg-hyk-medgrey">No social media was shared</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ViewNetworksSheet; 